
const adminPageMixin = {

    methods: {
        async initAdminPage() {
            localStorage.setItem('last_admin_route_name', this.$route.name)
        },
    }
};

export default adminPageMixin;
